module.exports = __webpack_public_path__ + "static/img/lALPD4Bhs5gnC9rNAbnNA7s_955_441.4f5ab83.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/lALPD4Bhs5gnC9rNAbnNA7s_955_441.png
// module id = 6NKo
// module chunks = 0